module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reporting"
  }, [_c('a', {
    staticClass: "d-back-link",
    attrs: {
      "href": "/calendar"
    }
  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _c('div', {
    staticClass: "reporting__header"
  }, [_c('div', {
    staticClass: "reporting__header__right"
  }, [_c('h1', [_vm._v("Grundskoleindberetning")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('StilGuides', {
    attrs: {
      "is-button": true
    }
  })], 1), _vm._v(" "), (_vm.isLoadingStilData || !_vm.isUserLoaded) ? _c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && _vm.userHasNoEmail) ? _c('div', {
    staticClass: "d-form alert"
  }, [_c('h3', [_vm._v("Der skal udfyldes en email for at benytte grundskoleindberetningen")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', [_vm._v("Din email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userEmailInput),
      expression: "userEmailInput",
      modifiers: {
        "trim": true
      }
    }],
    ref: "user_email_input",
    class: {
      'input--error': _vm.userEmailFormErrors['email']
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userEmailInput)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmailInput = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.userEmailFormErrors['email']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.email_error_text')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-form__submit"
  }, [_c('button', {
    staticClass: "bttn submit-button",
    class: [{
        'bttn--loading': _vm.isSavingUserEmail
      },
      {
        'submit-button--disabled': _vm.isSaveButtonForUserEmailDisabled
      }
    ],
    on: {
      "click": _vm.submitUserEmail
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && !_vm.isLoadingStilData && !_vm.userHasNoEmail) ? [_c('div', {
    staticClass: "d-tabs"
  }, [_c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 0
    },
    on: {
      "click": function($event) {
        _vm.theActiveTab = 0
      }
    }
  }, [_vm._v("\n        1. Personalets alder og køn\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 1
    },
    on: {
      "click": function($event) {
        _vm.theActiveTab = 1
      }
    }
  }, [_vm._v("\n        2. Ressourceforbrug\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 2
    },
    on: {
      "click": function($event) {
        _vm.theActiveTab = 2
      }
    }
  }, [_vm._v("\n        3. Antal elever og undervisningstimer\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.theActiveTab === 3
    },
    on: {
      "click": function($event) {
        _vm.theActiveTab = 3
      }
    }
  }, [_vm._v("\n        Resumé og indberetning\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "reporting-content"
  }, [_c('div', {
    staticClass: "reporting__table"
  }, [(_vm.theActiveTab === 0) ? _c('GrundskoleIndberetningUsers') : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 1) ? _c('GrundskoleIndberetningRessource', {
    attrs: {
      "stilData": _vm.stilData
    },
    on: {
      "updateStil": _vm.updateRessource
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('GrundskoleIndberetningTimetal', {
    attrs: {
      "stilData": _vm.stilData
    },
    on: {
      "update": _vm.update,
      "updateSubject": _vm.updateSubject,
      "updateKonfirmation": _vm.updateKonfirmation,
      "updatePraktik": _vm.updatePraktik,
      "setTolaerer": _vm.setTolaerer,
      "setForanstaltning": _vm.setForanstaltning,
      "nulstilKlasse": _vm.nulstilKlasse
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('GrundskoleIndberetningResume') : _vm._e()], 1)])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e282bfb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetning.vue
// module id = 2037
// module chunks = 1